function getBooleanEnvValue(value, defaultValue = false) {
    if (typeof value === "boolean") {
        return value;
    }
    const normalizedValue = String(value ?? "").trim().toLowerCase();
    if (!normalizedValue) {
        return defaultValue;
    }
    return ["1", "true", "yes", "on"].includes(normalizedValue);
}

const defaultConfig= {
    appTokenKey:"sj_mall_admin_token", // 集运token key
    mallAppTokenKey:"mall_app_user_key", // 商城token key
    isTbPurchaseOrderMode:"isTbPurchaseOrderMode", // 是否是淘宝采购1688订单
    layoutCommonConfig:{  // 商城配置
        header:{ 
            url:"poko-layout-header",
        },
        footer:{
            url:"poko-layout-footer",
        }
    },
    // layoutCommonConfig:{
    //     header:{
    //         url:"site-layout-header",
    //     },
    //     footer:{
    //         url:"site-layout-footer",   
    //     }
    // },
    devErpBuySite:false,// 开启erp采购调试
    isCmsSite:getBooleanEnvValue(process.env.IS_CMS_SITE, false), // 是否启用 CMS 站点 device 跳转
    disabledMallSsr:getBooleanEnvValue(process.env.DISABLED_MALL_SSR, false), // 是否关闭电商相关 SSR
    proxyLinks:{
        collectionSite: "tmallsitehost:7788",
        frontServerSite: "frontserverhost:7788",
        mallSite:"jyshoprelink:8081",
        qiankunSite: "pc-qiankun-site:7788",
        // collectionSite:"http://xjhy.shopmember-test.omszt.com:7888",
        // mallSite:"http://api-test.jyshop.omszt.com:8081",
        // qiankunSite:"http://xjhy.shopmember-test.omszt.com:7888",
       





        // collectionSite:"MPS-gateway-1:8897",
        // mallSite:"jyshoprelink:8081",
        // qiankunSite:"pc-qiankun-site:7788",

    }
} 
export default defaultConfig;
